export default {"src":"/_next/static/media/peas.13c65b65.svg","height":33,"width":70,"blurWidth":0,"blurHeight":0};